angular.module('gym.reports').controller('EditReportCtrl', ["$scope", "$state", "$window", "$document", "$timeout", "flash", "EditReportService", "Reports", "report", "reports", "title", "GTMService", "SubscriptionPlanLimitService", function($scope, $state, $window, $document, $timeout, flash, EditReportService, Reports, report, reports, title, GTMService, SubscriptionPlanLimitService) {
  $scope.report = report;
  $scope.reports = reports;
  $scope.title = title;
  $scope.tag_list = report.tag_list.map(function(tag) {
    return {
      text: tag
    };
  });
  if (!report.is_creator && report.locked) {
    $state.go('gym.reports.list');
  }
  GTMService.trackPage('Custom Report Edit');
  $scope.toggleColumn = function(column) {
    return EditReportService.toggleColumn(report, column);
  };
  $scope.toggleColumns = function(columns) {
    var selectAll;
    selectAll = !$scope.isSectionSelected(columns);
    return EditReportService.toggleColumns(report, columns, selectAll);
  };
  $scope.isColumnChecked = function(column) {
    column = _.findWhere(report.report_columns_attributes, {
      unique_id: column.unique_id
    });
    if (column) {
      return !column._destroy;
    }
  };
  $scope.isSectionSelected = function(section) {
    var hasUnselectedColumn;
    hasUnselectedColumn = _.find(section, function(column) {
      return !$scope.isColumnChecked(column);
    });
    return !hasUnselectedColumn;
  };
  $scope.onColumnMoved = {
    placeholder: 'ui-sortable-placeholder',
    forcePlaceholderSize: true,
    cancel: '.not-sortable'
  };
  $scope.aggregateLabel = function() {
    var ref, ref1;
    return (ref = $scope.report.report_aggregates_attributes) != null ? (ref1 = ref[0]) != null ? ref1.label : void 0 : void 0;
  };
  $scope.addTag = function(tag) {
    return EditReportService.addTag(report, tag);
  };
  $scope.removeTag = function(tag) {
    return EditReportService.removeTag(report, tag);
  };
  $scope.reportReady = function() {
    var columns;
    columns = _.filter(report.report_columns_attributes, function(column) {
      return !column._destroy;
    });
    return !$scope.isLoading && report.name && columns.length;
  };
  $scope.sectionHasSelectedColumns = function(section) {
    return _.find(section, function(column) {
      return $scope.isColumnChecked(column);
    });
  };
  $scope.isSectionCollapsed = function(key, section) {
    return key !== 'contact' && !$scope.sectionHasSelectedColumns(section);
  };
  $scope.selectedColumnsNumberInSection = function(section) {
    return _.filter(section, function(column) {
      return $scope.isColumnChecked(column);
    }).length;
  };
  $scope.cancel = function() {
    if (report.id) {
      return $state.go('gym.reports.show', {
        reportId: report.id
      });
    } else {
      return $state.go('gym.reports.list');
    }
  };
  return $scope.save = function() {
    GTMService.trackPage('Custom Report Edit', 'attempt');
    $scope.isLoading = true;
    return EditReportService.save(report.clone()).then(function(response) {
      $state.go('gym.reports.show', {
        reportId: response.data.id
      });
      return GTMService.trackPage('Custom Report Edit', 'success');
    }, function(response) {
      GTMService.trackPage('Custom Report Edit', 'error');
      SubscriptionPlanLimitService.validate(response.data);
      $scope.isLoading = false;
      $scope.report.errors = response.data.errors;
      if (response.data.errors) {
        flash.error = "Save failed. Please fix the errors below";
      }
      return $timeout(function() {
        var errorMessages;
        errorMessages = angular.element('.alert-danger');
        if (errorMessages.length) {
          return $document.scrollToElementAnimated(errorMessages[0], 200);
        }
      }, 100);
    });
  };
}]);
